
//CSS
import styles from "./excursionsGrid.module.less"
import {Link} from "react-router-dom";

export default function ExcursionsGrid ({excursions, language, zone, t}) {

  let excursionsHTML="";
  if (excursions.length > 0){
    excursionsHTML = excursions.map((excursion,index)=>{

      return (
        <div className={styles.excursion} key={index} data-excursionid={excursion.id}>
          <Link to={'/' + language + '/excursion/' + zone + '/' + excursion.webslug}>
            {excursion.webthumbnail && <img className={styles.webthumbnail} src={excursion.webthumbnail} alt={t('search.excursiongrid.imagen') + " " + excursion.webtitle}/>}
            {excursion.mobilethumbnail && <img className={styles.mobilethumbnail} src={excursion.mobilethumbnail} alt={t('search.excursiongrid.imagen') + " " + excursion.webtitle}/>}
            <div className={styles.sheet}>
              <div className={styles.background}>&nbsp;</div>
              <div className={styles.contentexcursion}>
                <div className={styles.name}>{excursion.webtitle}</div>
                <div
                  className={styles.price}>{t('search.excursiongrid.desde')}: <span> {excursion.pricehighlight.price?.toFixed(2)}  &euro;</span>
                </div>
              </div>
            </div>
          </Link>
        </div>
      )
    });
  } else excursionsHTML=t('search.excursiongrid.No hay excursiones');

  return(
    <div className={styles.excursions}>
      {excursionsHTML}
    </div>
  )
}

